import { styled } from '@mui/material/styles';
import * as React from 'react';
const StyledSvg = styled('svg')({});
export default StyledSvg;
